import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import * as React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface Props extends Pick<MenuItemProps, 'children'> {
    pathname: string;
}

export default function NavLinkMenuItem({ pathname, ...menuItemProps }: Props) {
    const NavLink = React.useMemo(
        () =>
            React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>((props, ref) => (
                <RouterLink ref={ref} to={pathname} {...props} />
            )),
        [pathname],
    );

    return <MenuItem component={NavLink}>{menuItemProps.children}</MenuItem>;
}
